import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/expiredLink.module.css';

const ExpiredLink: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <svg className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/>
          </svg>
        </div>
        
        <h1 className={styles.title}>This Link Has Expired</h1>
        
        <p className={styles.message}>
          Recovery Commons automatically removes shared links after 7 days for privacy and security.
        </p>
        
        <p className={styles.submessage}>
          To view this person's current progress, please ask them to share again.
        </p>
        
        <button 
          className={styles.homeButton}
          onClick={() => navigate('/')}
        >
          Go to Recovery Commons
        </button>
      </div>
    </div>
  );
};

export default ExpiredLink;

